import React from 'react';
import PropTypes from 'prop-types';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

const TextEditor = props => {
  const { onChange, data,disabled } = props;
  return (
    <div>
      <CKEditor
        editor={ClassicEditor}
        data={data}
        disabled={disabled}
        onChange={(event, editor) => {
          const data = editor.getData();
          onChange(data);
        }}
      />
    </div>
  );
};

TextEditor.propTypes = {
  data: PropTypes.string,
  onChange: PropTypes.func,
};

TextEditor.defaultProps = {
  data: '',
  onChange: () => {},
};

export default TextEditor;
